import React from 'react'
import { Typography, Grid, makeStyles, createStyles, Chip, Box } from '@material-ui/core'

interface ImagePreviewProps {
  url: string

  name: string

  isMain?: boolean
}

export const ImagePreview = ({url, name, isMain}: ImagePreviewProps) => {
  const classes = useStyles()

  return (
    <Grid container alignItems="center" className={classes.previewItem}>
      <img src={url} alt={name} className={classes.previewImage}/>
      <Box className={classes.labelWrapper}>
        <Typography>{name}</Typography>
      </Box>
      {isMain && (
        <Chip
          label="Главная"
          color="primary"
          size="small"
          className={classes.mainChip}
        />
      )}
    </Grid>
  )
}

const useStyles = makeStyles(() =>
  createStyles({
    previewItem: {
      display: 'flex',
      alignItems: 'center',
      borderRadius: 4,
      position: 'relative',
      overflow: 'hidden',
      height: '100%'
    },
    labelWrapper: {
      position: 'absolute',
      bottom: '0',
      left: '0',
      width: 'calc(100% - 16px)',
      padding: 8,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      backdropFilter: 'blur(5px)',
      color: 'white'
    },
    previewImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      marginRight: 12,
      borderRadius: 4
    },
    mainChip: {
      position: 'absolute',
      right: 40,
      top: 10,
      fontWeight: 'bold',
      fontSize: 10,
      backgroundColor: '#1976d2',
      color: '#fff'
    }
  })
)
